export const VISITOR_CUSTOM_FIELD_TYPE_VALUES = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  SELECT_DROPDOWN: 'select_dropdown',
  SELECT_RADIO: 'select_radio',
  MULTI_SELECT: 'multi_select',
} as const;

export type VisitorCustomFieldType =
  (typeof VISITOR_CUSTOM_FIELD_TYPE_VALUES)[keyof typeof VISITOR_CUSTOM_FIELD_TYPE_VALUES];

export type VisitorCustomFieldPlainTextType =
  | typeof VISITOR_CUSTOM_FIELD_TYPE_VALUES.TEXT
  | typeof VISITOR_CUSTOM_FIELD_TYPE_VALUES.TEXTAREA;


export type VisitorCustomFieldSelectType =
  | typeof VISITOR_CUSTOM_FIELD_TYPE_VALUES.SELECT_DROPDOWN
  | typeof VISITOR_CUSTOM_FIELD_TYPE_VALUES.SELECT_RADIO
  | typeof VISITOR_CUSTOM_FIELD_TYPE_VALUES.MULTI_SELECT;

export function isVisitorCustomFieldSelectType(
  fieldType: VisitorCustomFieldType
): fieldType is VisitorCustomFieldSelectType {
  return (
    fieldType === VISITOR_CUSTOM_FIELD_TYPE_VALUES.SELECT_DROPDOWN ||
    fieldType === VISITOR_CUSTOM_FIELD_TYPE_VALUES.SELECT_RADIO ||
    fieldType === VISITOR_CUSTOM_FIELD_TYPE_VALUES.MULTI_SELECT
  );
}

export function isVisitorCustomFieldPlainTextType(
  fieldType: VisitorCustomFieldType
): fieldType is VisitorCustomFieldPlainTextType {
  return (
    fieldType === VISITOR_CUSTOM_FIELD_TYPE_VALUES.TEXT ||
    fieldType === VISITOR_CUSTOM_FIELD_TYPE_VALUES.TEXTAREA
  );
}
